<div class="mx-auto max-w-7xl relative px-4 sm:px-6 lg:px-8 z-10" #cookieDeclaration id="cookieDeclaration"></div>